import { connect } from 'react-redux';
import React from 'react';
import propTypes from 'prop-types';

import Toolbox from '../components/Toolbox';

class WidgetContainer extends React.Component {
	render() {
		return <Toolbox {...this.props} />;
	}
}

WidgetContainer.propTypes = {
	deviceType: propTypes.string.isRequired,
	vehicleId: propTypes.string.isRequired,
	pageAlias: propTypes.string.isRequired,
	tabList: propTypes.shape({
		accessories: propTypes.shape({
			complete: propTypes.bool,
			textAlias: propTypes.string,
			time: propTypes.string
		}),
		finance: propTypes.shape({
			complete: propTypes.bool,
			textAlias: propTypes.string,
			time: propTypes.string
		}),
		prequal: propTypes.shape({
			complete: propTypes.bool,
			textAlias: propTypes.string,
			time: propTypes.string
		}),
		payment: propTypes.shape({
			complete: propTypes.bool,
			textAlias: propTypes.string,
			time: propTypes.string
		}),
		protect: propTypes.shape({
			complete: propTypes.bool,
			textAlias: propTypes.string,
			time: propTypes.string
		}),
		reserve: propTypes.shape({
			complete: propTypes.bool,
			textAlias: propTypes.string,
			time: propTypes.string
		}),
		trade: propTypes.shape({
			complete: propTypes.bool,
			textAlias: propTypes.string,
			time: propTypes.string
		})
	}).isRequired,
	vehicleInfo: propTypes.shape({
		bodyStyle: propTypes.shape({
			_type: propTypes.string,
			en_US: propTypes.string
		}),
		chromeId: propTypes.string,
		internetPrice: propTypes.number,
		make: propTypes.string,
		model: propTypes.shape({
			_type: propTypes.string,
			en_US: propTypes.string
		}),
		normalBodyStyle: propTypes.shape({
			_type: propTypes.string,
			en_US: propTypes.string
		}),
		trim: propTypes.shape({
			_type: propTypes.string,
			en_US: propTypes.string
		}),
		type: propTypes.string,
		uuid: propTypes.string,
		vin: propTypes.string,
		year: propTypes.string
	}).isRequired,
	paymentInfo: propTypes.arrayOf(
		propTypes.shape({
			payments: propTypes.arrayOf(
				propTypes.shape({
					annualMiles: propTypes.number,
					apr: propTypes.number,
					downPayment: propTypes.number,
					financeType: propTypes.string,
					lenderLegalName: propTypes.string,
					payment: propTypes.number,
					programEndDate: propTypes.string
				})
			)
		})
	).isRequired,
	locale: propTypes.string.isRequired
};

const mapStateToProps = state => {
	return {
		deviceType: state.requestData.deviceType,
		vehicleId: state.vehicleId,
		pageAlias: state.pageAlias,
		tabList: state.tabList,
		vehicleInfo: state.vehicleInfo,
		paymentInfo: state.paymentInfo,
		widgetClasses: state.widgetClasses,
		locale: state.locale
	};
};

const mapDispatchToProps = _dispatch => ({});

const Widget = connect(
	mapStateToProps,
	mapDispatchToProps
)(WidgetContainer);

export default Widget;



// WEBPACK FOOTER //
// ./src/containers/Widget.jsx